import React, { useEffect, useState } from 'react'
import { GetAll_Active_SubPeriod_Api } from '../../API/SubPeriodApi';
import { Col, Row, Select } from 'antd';
import { Option } from 'antd/es/mentions';
import { SetReserveTime_Reserve_Api, SetReserveTimeFromSubPeriod_Reserve_Api } from '../../API/ReserveApi';
import dayjs from 'dayjs'
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
// ===================================================================== 
export const TimesComponent = ({ setLoading, showMessage, reserve, onTimeChanged }) => {
    // ====================================================================== 
    const [subPeriods, setSubPeriods] = useState(0);

    const [fromDate, setFromDate] = useState();
    const [fromDateBase, setFromDateBase] = useState();

    const [toDate, setToDate] = useState();
    const [toDateBase, setToDateBase] = useState();
    // =================================================================
    const initFromDate = (dt) => {
        setFromDate(dt);
        dayjs.calendar('jalali');
        var fd = dayjs(dt, { jalali: true });
        setFromDateBase(fd);
    }
    // =================================================================
    const initToDate = (dt) => {
        setToDate(dt);
        dayjs.calendar('jalali');
        var fd = dayjs(dt, { jalali: true });
        setToDateBase(fd);
    }
    // ====================================================================== 
    useEffect(() => {
        if (reserve.from_Shamsi)
            initFromDate(reserve.from_Shamsi);
        if (reserve.to_Shamsi)
            initToDate(reserve.to_Shamsi);
        if (reserve.period && reserve.period.isTimesFix)
            loadSubPeriods();
    }, [reserve]);
    // ======================================================================
    const loadSubPeriods = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Active_SubPeriod_Api(reserve.periodId);
            setLoading(false);

            if (data.messageStatus == "Successful")
                setSubPeriods(data.messageData.data);

            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const setTimeFromSubPeriod = async (subPeriodId) => {
        setLoading(true);
        try {

            var params =
            {
                "reserveId": reserve.id,
                "subPeriodId": subPeriodId
            };
            const data = await SetReserveTimeFromSubPeriod_Reserve_Api(params);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                reserve.subPeriodId = subPeriodId;
                if (onTimeChanged) onTimeChanged();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const setTime = async (from, to) => {
        setLoading(true);
        try {

            var params =
            {
                "reserveId": reserve.id,
                "fromDateShamsi": from,
                "toDateShamsi": to,

            };
            const data = await SetReserveTime_Reserve_Api(params);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                if (onTimeChanged) onTimeChanged();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    // const handleChange = (value) => {
    //     if (reserve.period.isTimesFix)
    //         setTimeFromSubPeriod(value);
    //     else
    //         setTime();
    // };
    // ======================================================================
            // ابتدا outside از return محاسبه کنید
const periodOptions = React.useMemo(() => {
    if (!subPeriods || subPeriods.length === 0) return [];
    
    return [
        {
            value: null,
           // value: 0,
            label: '--- لطفاً یک تاریخ انتخاب کنید ---',
            disabled: true
        },
        ...subPeriods.map(subPeriod => ({
            value: subPeriod.id,
            label: `از ${subPeriod.from_Shamsi} لغایت ${subPeriod.to_Shamsi}`,
            data: subPeriod // ذخیره داده کامل برای دسترسی بعدی
        }))
    ];
}, [subPeriods]); // وابسته به subPeriods

// سپس در JSX
    return (
        <>


            {/* اگر تایم فیکس است باید از تایم های زیردوره ها انتخاب شود */}
{(reserve.period.isTimesFix && subPeriods) &&
    <div className='container'>
        <Row justify='space-around'>
            <Col span={24} style={{ 
                textAlign: 'center', 
                paddingBottom: '5px', 
                borderBottom: '1px solid #cdcdcd', 
                marginBottom: '10px' 
            }}>
                تاریخ مورد نظر خود را انتخاب کنید:
            </Col>
            
            <Select
                placeholder="انتخاب تاریخ"
                style={{ width: '100%' }}
                onChange={setTimeFromSubPeriod}
                value={reserve.subPeriodId}
                options={periodOptions}
                //allowClear
                showSearch
                filterOption={(input, option) => 
                    option.label.toLowerCase().includes(input.toLowerCase())
                }
            />
        </Row>
    </div>
}
            {(localStorage.getItem('role') == 'SuperAdmin'
                || localStorage.getItem('role') == 'Admin') ||
                !reserve.period.isTimesFix ?
                <>
                    <div className='container'>
                        <Row
                            justify='space-around'
                            style={{}}
                        >
                            <Col span={24} style={{ textAlign: 'center', paddingBottom: '5px', borderBottom: '1px solid #cdcdcd', marginBottom: '10px' }}>
                                بازه زمانی را انتخاب کنید:
                            </Col>
                            <JalaliLocaleListener />
                            <DatePickerJalali.RangePicker
                                value={[fromDateBase, toDateBase]} // مقدار بازه زمانی
                                placeholder={["تاریخ شروع", "تاریخ پایان"]}
                                onChange={(dates, dateStrings) => {
                                    const [start, end] = dateStrings;
                                    initFromDate(start); // ذخیره تاریخ شروع
                                    initToDate(end);     // ذخیره تاریخ پایان
                                    setTime(start, end);
                                }}
                            />
                        </Row>

                    </div>

                </>
                :
                <></>}

        </>
    )
}
